/**
 * Configuracion del Arbol general de estados de la aplicacion
 */

/**Definicion de componentes o librerias necesarias y que se complementan con el almacen de estados */
import Vue from 'vue'
import Vuex from 'vuex'
import Session from './session/session'
import Notifications from './generic/notifications'

/**Integramos el almacen de estados de Vuejs */
Vue.use(Vuex)

/**
 * Definimos el modulo propio para el manejo de estados de la aplicacion
 */
export default new Vuex.Store({

  /**Objeto que permite definir los modulos que hacen parte del estado general de la aplicacion */
  modules: {

    /**Se inyecta el almacen de estados para el manejo de sesion en la aplciacion */
    Session,

    /**Se inyecta el almacen de estados para el manejo de notificaciones en la aplicacion */
    Notifications,
  }
})
